import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import BackBtn from "../../widgets/BackBtn";
import AddIcon from "@mui/icons-material/Add";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { toast } from "react-toastify";
import ImageCropperModal from "../../widgets/ImageCropperModal";
import FullImageModal from "../../widgets/FullImageModal";
import { API_ENDPOINT, APP_ID } from "../../utils/constants";
import useGetEventSettings from "../../hooks/useGetEventSettings";
import MuPb from "../../widgets/MuPb";
import { getErrorResponse } from "../../utils/util";
import { Link } from "react-router-dom";

const EventSettings = () => {
  const { data, isLoading, refetch, isError, error } = useGetEventSettings();
  const [showImage, setShowImage] = useState(false);
  const [imageToShow, setImageToShow] = useState("");
  const [config, setConfig] = useState({
    socialWallBanner: "",
    loginBanner: "",
    eventLogo: "",
    studentBadgeBg: "",
    defProfileBanner: "",
    eventBanner: "",
  });
  const [cropperOpen, setCropperOpen] = useState(false);
  const [propertyType, setPropertyType] = useState("");
  const [aspectRatio, setAspectRatio] = useState(2 / 1);
  const handleChange = (path, value) => {
    const paths = path.split(".");
    setConfig((prev) => ({
      ...prev,
      [paths[0]]:
        paths.length === 1
          ? value
          : {
              ...prev[paths[0]],
              [paths[1]]: value,
            },
    }));
  };
  useEffect(() => {
    if (data) {
      setConfig({
        socialWallBanner: data.socialWallBanner,
        loginBanner: data.loginBanner,
        eventLogo: data.eventLogo,
        defProfileBanner: data.defProfileBanner,
        eventBanner: data.eventBanner,
        studentBadgeBg: data.studentBadgeBg,
      });
    }
  }, [data]);

  const handleUploadSuccess = (response) => {
    toast.success(response.message);
    refetch();
  };
  const handleCloseImage = () => {
    setShowImage(false);
  };
  const handleShowImage = (imgUrl) => {
    setImageToShow(imgUrl);
    setShowImage(true);
  };
  if (isLoading) {
    return <MuPb />;
  }
  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }
  return (
    <Container maxWidth="md">
      <FullImageModal
        imgUrl={imageToShow}
        open={showImage}
        handleClose={handleCloseImage}
      />
      <ImageCropperModal
        open={cropperOpen}
        type={propertyType}
        onClose={() => setCropperOpen(false)}
        aspectRatio={aspectRatio}
        maxSizeKB={1024}
        uploadUrl={`${API_ENDPOINT}event/upload-image-event-settings-main/${propertyType}`}
        headers={{
          dbauth: APP_ID, //db: testapp
        }}
        onSuccess={handleUploadSuccess}
        onError={(error) => console.error("Upload error:", error)}
      />
      <BackBtn />
      <Box>
        <Paper sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            Set Social Wall banner for <strong>{data?.eventName}</strong>
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Stack direction={"row"} gap={1}>
                <TextField
                  size="small"
                  fullWidth
                  disabled
                  label="Social wall Banner"
                  value={config.socialWallBanner}
                  onChange={(e) =>
                    handleChange("socialWallBanner", e.target.value)
                  }
                />
                <IconButton
                  onClick={() => {
                    handleShowImage(config.socialWallBanner);
                  }}
                  size="small"
                >
                  <VisibilityOutlinedIcon fontSize="small" />
                </IconButton>
                <Button
                  onClick={() => {
                    setPropertyType("socialWallBanner");
                    setAspectRatio(800 / 450);
                    setCropperOpen(true);
                  }}
                  variant="outlined"
                  startIcon={<AddIcon />}
                  size="small"
                >
                  Change
                </Button>
              </Stack>
              <Alert severity="info">To be used in Social Wall Banner</Alert>
            </Grid>
            <Grid item xs={12}>
              <Stack direction={"row"} gap={1}>
                <TextField
                  size="small"
                  fullWidth
                  disabled
                  label="Login Banner"
                  value={config.loginBanner}
                  onChange={(e) => handleChange("loginBanner", e.target.value)}
                />
                <IconButton
                  onClick={() => {
                    handleShowImage(config.loginBanner);
                  }}
                  size="small"
                >
                  <VisibilityOutlinedIcon fontSize="small" />
                </IconButton>
                <Button
                  onClick={() => {
                    setPropertyType("loginBanner");
                    setAspectRatio(1080 / 1080);
                    setCropperOpen(true);
                  }}
                  variant="outlined"
                  startIcon={<AddIcon />}
                  size="small"
                >
                  Change
                </Button>
              </Stack>
              <Alert severity="info">
                To be used in login banner in Login Page
              </Alert>
            </Grid>
            <Grid item xs={12}>
              <Stack direction={"row"} gap={1}>
                <TextField
                  size="small"
                  fullWidth
                  disabled
                  label="Event Logo"
                  value={config.eventLogo}
                  onChange={(e) => handleChange("eventLogo", e.target.value)}
                />
                <IconButton
                  onClick={() => {
                    handleShowImage(config.eventLogo);
                  }}
                  size="small"
                >
                  <VisibilityOutlinedIcon fontSize="small" />
                </IconButton>
                <Button
                  onClick={() => {
                    setPropertyType("eventLogo");
                    setAspectRatio(500 / 167);
                    setCropperOpen(true);
                  }}
                  variant="outlined"
                  startIcon={<AddIcon />}
                  size="small"
                >
                  Change
                </Button>
              </Stack>
              <Alert severity="info">To be used in App Bar of dashboard</Alert>
            </Grid>

            <Grid item xs={12}>
              <Stack direction={"row"} gap={1}>
                <TextField
                  size="small"
                  fullWidth
                  disabled
                  label="Student Badge Bg"
                  value={config.studentBadgeBg}
                  onChange={(e) =>
                    handleChange("studentBadgeBg", e.target.value)
                  }
                />
                <IconButton
                  onClick={() => {
                    handleShowImage(config.studentBadgeBg);
                  }}
                  size="small"
                >
                  <VisibilityOutlinedIcon fontSize="small" />
                </IconButton>
                <Button
                  onClick={() => {
                    setPropertyType("studentBadgeBg");
                    setAspectRatio(1243 / 1757);
                    setCropperOpen(true);
                  }}
                  variant="outlined"
                  startIcon={<AddIcon />}
                  size="small"
                >
                  Change
                </Button>
              </Stack>
              <Alert severity="info">To be used to preview student badge</Alert>
            </Grid>

            <Grid item xs={12}>
              <Stack direction={"row"} gap={1}>
                <TextField
                  size="small"
                  fullWidth
                  disabled
                  label="Default Profile Banner"
                  value={config.defProfileBanner}
                  onChange={(e) =>
                    handleChange("defProfileBanner", e.target.value)
                  }
                />
                <IconButton
                  onClick={() => {
                    handleShowImage(config.defProfileBanner);
                  }}
                  size="small"
                >
                  <VisibilityOutlinedIcon fontSize="small" />
                </IconButton>
                <Button
                  onClick={() => {
                    setPropertyType("defProfileBanner");
                    setAspectRatio(640 / 214);
                    setCropperOpen(true);
                  }}
                  variant="outlined"
                  startIcon={<AddIcon />}
                  size="small"
                >
                  Change
                </Button>
              </Stack>
              <Alert severity="info">
                To be used as Profile Banner default for Visitor/Exhibitor
                Profile Details view
              </Alert>
            </Grid>
            <Grid item xs={12}>
              <Stack direction={"row"} gap={1}>
                <TextField
                  size="small"
                  fullWidth
                  disabled
                  label="Event Banner(ar: 780 / 237)"
                  value={config.eventBanner}
                  onChange={(e) => handleChange("eventBanner", e.target.value)}
                />
                <IconButton
                  onClick={() => {
                    handleShowImage(config.eventBanner);
                  }}
                  size="small"
                >
                  <VisibilityOutlinedIcon fontSize="small" />
                </IconButton>
                <Button
                  onClick={() => {
                    setPropertyType("eventBanner");
                    setAspectRatio(780 / 237);
                    setCropperOpen(true);
                  }}
                  variant="outlined"
                  startIcon={<AddIcon />}
                  size="small"
                >
                  Change
                </Button>
              </Stack>
              <Alert severity="info">
                To be used in Forgot Password, Reset Password etc.
              </Alert>
            </Grid>
          </Grid>

          <Box my={1}>
            <Typography mt={1} variant="h6" textAlign={"center"}>
              <Link to={`${data?.regLink}/student-registration`}>
                Student Registration
              </Link>
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default EventSettings;
